"use strict";
require("./account-dashboard-banner");
require("./additional-benefits");
require("./articleslist");
require("./article-restricted-content");
require("./call-to-action");
require("./container/Container");
require("./content-restriction");
require("./core/image/Image");
require("./core/separator/Separator");
require("./core/text/Text");
require("./core/title/Title");
require("./earn-points");
require("./faq/Faq");
require("./header-block");
require("./hero/Hero");
require("./heroV2/HeroV2");
require("./heroV2-container/HeroV2Container");
require("./html-container");
require("./image-info-banner");
require("./loyalty-points-status");
require("./overview");
require("./pack-codes");
require("./points-amount-banner");
require("./points-history");
require("./pushblock");
require("./qr-code-points-collection");
require("./refer-a-friend");
require("./referral-history");
require("./referral-personal-code");
require("./referral-stats");
require("./simplified-prizes");
require("./survey");
require("./tabs/Tabs");
require("./tiers-benefits");
require("./trusted-places/TrustedPlaces");
require("./video-player/VideoPlayer");
require("./qr-code-lottery");
require("./mgm-account-dashboard");
require("./loyalty-contact-form");
require("./referral-stats-dashboard");
require("./page-title");
